module.exports = __webpack_public_path__ + "img/qr.f6e7b46c.png";